import { render, staticRenderFns } from "./BranceSale.vue?vue&type=template&id=2a22b6a0"
import script from "./BranceSale.vue?vue&type=script&lang=js"
export * from "./BranceSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports